/*=========================================================================================
  File Name: module-licenseinfo-mutations.js
  Description: LicenseInfo Module Mutations
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import commonFunc from '@/common/commonFunction';

export default {
	updateLicenseInfo(state, res) {
		state.LicenseInfo = res;
	},
	updateConfig(state, res) {
		state.Config = res;
	},
	updateLicenseWarning(state, res) {
		state.LicenseWarning = res;
	},
	updateLicenseWarningShowHeader(state, res) {
		if (!state.LicenseWarning) return;
		state.LicenseWarning.IsShowWarningBanner = res;
	},
	updateLicenseInfoNotification(state, res) {
		state.LicenseInfoNotification = res;
	}
};
